import { render, staticRenderFns } from "./EventEmployeeDetail.vue?vue&type=template&id=6b5642d6&scoped=true"
import script from "./EventEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./EventEmployeeDetail.vue?vue&type=script&lang=js"
import style0 from "./EventEmployeeDetail.vue?vue&type=style&index=0&id=6b5642d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5642d6",
  null
  
)

export default component.exports